import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import useApi from "../../services/api";
import { UpdateUser } from "../../store/reducers/auth.reducer";
import { handleApiErrors } from "../../utils/handleErrors";

/**
 * A hook to query the user logged on the backend and put it in the redux state
 */
export const useGetUser = () => {
  const { logged } = useSelector((store) => store.auth);

  const dispatch = useDispatch();
  const { ApiGetUser } = useApi();

  useEffect(() => {
    let isMounted = true;

    if (logged) {
      const getUser = async () => {
        const { data } = await ApiGetUser();

        if (!isMounted) return;

        if (data.errors) {
          return handleApiErrors(data.errors);
        }

        dispatch(UpdateUser(data));
      };

      getUser();
    }

    return () => {
      isMounted = false;
    };
  }, [ApiGetUser, dispatch, logged]);
};

export default useGetUser;
